<div mat-dialog-title class="dialog-info p-0 m-0" closeOnEscape>
    <label class="dialogTitle horizontal-padding">
      {{ 'PROPERTIES_PROPOSAL_OPTIONAL_PAGE_TITLE' | translate }}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross horizontal-padding" [mat-dialog-close]></button>
</div>
<mat-dialog-content [formGroup]="optionalPageSelectionForm" class="horizontal-padding vertical-padding dialog-content">
    <div class="row m-0">
        <label class="p-0">
            {{ 'PROPERTIES_PROPOSAL_TEMPLATE_PAGE_DESCRIPTION' | translate }}
        </label>
    </div>
    <div class="row m-0">
        <div class="col-sm-12 p-0">
            <mat-radio-group formControlName="pageSelectionOption" (change)="updateUserDefinedControls()">
                <mat-radio-button  color="primary" [value]="true" class="align-buttons">
                    {{ 'PROPERTIES_PROPOSAL_USER_TEMPLATE_DEFAULTS' | translate }}
                </mat-radio-button>
                <fieldset class="horizontal-padding mb-1">
                    <legend>
                        <mat-radio-button color="primary" [value]="false" class="ml-3">
                            {{ 'PROPERTIES_PROPOSAL_USER_DEFINED' | translate }}
                        </mat-radio-button>
                    </legend>
                    <ng-container *ngTemplateOutlet="userDefinedTemplate"></ng-container>
                </fieldset>
            </mat-radio-group>
        </div>
        <div class="row m-0 p-0">
            <mat-checkbox color="primary" formControlName="includeFinancingOptions" class="align-buttons">
                {{ 'PROPERTIES_PROPOSAL_INCLUDE_FINANCING_OPTIONS' | translate }}
            </mat-checkbox>
        </div>
        <ng-template #userDefinedTemplate>
            <div class="row col-sm-12 m-0 mt-1">
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="coverPage">{{ 'PROPERTIES_PROPOSAL_COVER_PAGE' | translate }}</mat-checkbox>
                </div>
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="clarifications">{{ 'PROPERTIES_PROPOSAL_CLARIFICATIONS' | translate }}</mat-checkbox>
                </div>
                 <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="terms">{{ 'PROPERTIES_PROPOSAL_TERMS_CONDITIONS' | translate }}</mat-checkbox>
                </div>
            </div>
            <div class="row col-sm-12 m-0 mt-1">
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="scopeOfwork">{{ 'PROPERTIES_PROPOSAL_SCOPE_OF_WORK' | translate }}</mat-checkbox>
                </div>
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="proposedSolution">{{ 'PROPERTIES_PROPOSAL_PROPOSED_SOLUTION' | translate }}</mat-checkbox>
                </div>
                 <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="signaturePage">{{ 'PROPERTIES_PROPOSAL_SIGNATURE_PAGE' | translate }}</mat-checkbox>
                </div>
            </div>
            <div class="row col-sm-12 m-0 mt-1">
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="inclusions">{{ 'PROPERTIES_PROPOSAL_INCLUSIONS' | translate }}</mat-checkbox>
                </div>
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="paymentTerms">{{ 'PROPERTIES_PROPOSAL_PAYMENT_TERMS' | translate }}</mat-checkbox>
                </div>
            </div>
             <div class="row col-sm-12 m-0 mt-1">
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="exclusions">{{ 'PROPERTIES_PROPOSAL_EXCLUSIONS' | translate }}</mat-checkbox>
                </div>
                <div class="col-sm-4 p-0">
                    <mat-checkbox color="primary" formControlName="references">{{ 'PROPERTIES_PROPOSAL_REFERENCES' | translate }}</mat-checkbox>
                </div>
            </div>
        </ng-template>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions border-0">
      <button mat-button color="primary" (click)="onOkClick()">{{'OK' | translate}}</button>
      <button mat-button color="warn" mat-dialog-close>{{'CANCEL' | translate}}</button>
</mat-dialog-actions>
